import { FC } from "react";
import { Control, UseFormHandleSubmit } from "react-hook-form";
import { Button } from "..";
import { ErrorSummary } from "../../utils/errorSummary";
import { MaterialInput2 } from "../UIKit/Input/MaterialInput";
import { MaterialSelect2 } from "../UIKit/Select/MaterialSelect";
import { IFormInput } from "./model";

export const SearchForm: FC<{
  errors: any;
  handleSubmit: UseFormHandleSubmit<IFormInput>;
  refetchFlightData: any;
  control: Control<IFormInput, any>;
  isRefetching: boolean;
}> = ({ errors, handleSubmit, refetchFlightData, control, isRefetching }) => {
  const searchHandler = (data: any) => {
    console.log("submitted Data", data);
    refetchFlightData();
  };
  return (
    <>
      <div className="mb-3">
        <ErrorSummary errors={errors} />
      </div>
      <form
        onSubmit={handleSubmit(searchHandler)}
        className="flex flex-wrap items-end gap-6 w-full"
      >
        <MaterialInput2
          control={control}
          name="startDate"
          label="Start Date"
          type="date"
          containerClass="w-40"
        />

        <MaterialInput2
          control={control}
          name="endDate"
          label="End Date"
          type="date"
          containerClass="w-40"
        />

        <MaterialSelect2
          containerClass="w-40"
          control={control}
          name="arrivalAirport"
          label={<span className="text-gray-300">Arrival Airport</span>}
          options={[
            { label: "", value: null },
            { label: "Murtala Muhammed International Airport", value: "MMA" },
            { label: "Nnamdi Azikiwe International Airport", value: "NAA" },
          ]}
        />

        <MaterialSelect2
          containerClass="w-40"
          control={control}
          name="departureAirport"
          label={<span className="text-gray-300">Departure Airport</span>}
          options={[
            { label: "", value: null },
            { label: "Murtala Muhammed International Airport", value: "MMA" },
            { label: "Nnamdi Azikiwe International Airport", value: "NAA" },
          ]}
        />
        <MaterialSelect2
          containerClass="w-40"
          control={control}
          name="airline"
          label={<span className="text-gray-300">Airline</span>}
          options={[
            { label: "", value: null },
            { label: "Dana Airlines", value: 10 },
            { label: "Air Peace", value: 20 },
          ]}
        />

        <MaterialInput2
          control={control}
          name="registrationNo"
          label="Registration No"
          type="text"
          containerClass="w-40"
        />

        <MaterialInput2
          control={control}
          name="flightNo"
          label="Flight No"
          type="text"
          containerClass="w-40"
        />

        <Button
          label="Search"
          className="w-40"
          variant="filled"
          isLoading={isRefetching}
        />
      </form>
    </>
  );
};
